<template>
  <router-link
    :class="{ 'button--solid': solid }"
    v-bind="$attrs"
    class="button"
  >
    <slot/>
  </router-link>
</template>

<script>
import BButton from '@/components/base/BButton'

export default {
  name: 'CButtonRouterLink',

  extends: BButton
}
</script>
